import React, { useState, useRef } from 'react';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Base, Button, toast } from 'src/components';
import STYLE from 'src/constants/style';
import HeaderV2 from 'src/containers/Header/HeaderV2';
import SpinnerSVG from 'src/assets/svg/spinner.svg';
import { uploadGoalsQuery, downloadGoalsSampleQuery } from 'src/containers/Goals/queries';
import UploadGoalsErrors from 'src/pagesDashboard/UploadGoals/UploadGoalsErrors';

const UploadGoals = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const fileInputRef = useRef(null);
  const { mutateAsync: uploadFile, isLoading: updateFileLoading } = uploadGoalsQuery();
  const { mutateAsync: downloadSample, isLoading: downloadSampleLoading } = downloadGoalsSampleQuery();

  const [local, setLocal] = useState({ goalsFile: null });
  const [uploadErrors, setUploadErrors] = useState([]);

  const isMutating = updateFileLoading || downloadSampleLoading;

  const exportFn = async () => {
    await downloadSample({
      filename: 'Goal Upload Template'
    });
    toast.show('Download successful');
  };

  const upload = async () => {
    const formData = new FormData();
    formData.append('excel', local.goalsFile);
    toast.show('Uploading goals');
    setUploadErrors([]);
    const result = await uploadFile(formData);
    if (result.failed.length) {
      setUploadErrors(result.failed);
    } else {
      toast.show('Done!');
      queryClient.invalidateQueries('goals');
    }
    setLocal({ goalsFile: null });
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
  };

  const selectFile = (event) => {
    setLocal({ goalsFile: event.target.files[0] });
  };

  return (
    <>
      <HeaderV2 overtitle='Tracking' title='Goals' />
      <Base className={STYLE.BASE}>
        <h5 className='mb-4'>Upload Goals</h5>
        <p className='bg-blue-100 text-blue-900 p-4 rounded-lg border border-blue-300 shadow-sm'>
          Uploading a set of goals will upload (and create) all the goals specified on your spreadsheet. (Accepts csv and xlsx files)
          <br />
          This feature does not allow for editing existing goals within the system at this time.
        </p>
        <input
          className='w-[410px]'
          ref={fileInputRef}
          onChange={selectFile}
          type='file'
          disabled={isMutating}
        />
        <div>
          <div className='flex gap-3 mt-2'>
            <Button
              variant='black'
              classes='py-1 whitespace-nowrap h-[39.5px]'
              onClick={upload}
              disabled={!local.goalsFile || isMutating}
            >
              Upload
            </Button>
            <Button
              variant='black'
              classes='py-1 whitespace-nowrap h-[39.5px]'
              onClick={() => exportFn()}
              disabled={isMutating}
            >
              Download Sample
            </Button>
            <Button
              variant='black'
              classes='py-1 whitespace-nowrap h-[39.5px]'
              onClick={() => navigate('/dashboard/goals')}
            >
              Close
            </Button>
          </div>
          {
            isMutating ? (
              <div className='flex items-center justify-center h-full w-full mt-14'>
                <SpinnerSVG className='w-8 h-8' />
              </div>
            ) : null
          }
          {
            uploadErrors.length ? (
              <UploadGoalsErrors
                errors={uploadErrors}
              />
            ) : null
          }
        </div>
      </Base>
    </>
  );
};

export default UploadGoals;
